module.exports = __webpack_public_path__ + "img/3_sales_navigator.c0d75c50.png";